import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Draggable from "react-draggable";
import {
  AssetsDatePicker,
  AssetsTextInput2,
} from "../../components/assetsInputs";
import dayjs from "dayjs";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  DialogActions,
  Button,
} from "@mui/material";
import {
  selectAppUser,
  selectInvoicingSteps,
} from "../../store/selectors/navigation";
import {
  selectContractsList,
  selectSelectedContract,
  selectContractDetails,
  selectOrderlineEndDateEdit,
  selectOrderlineInvoiceDateEdit,
  selectOrderlineInvoiceTwid,
} from "../../store/selectors/invoicing";
import {
  getAppUser,
  setCategories,
  storeTablesFilters,
  setInvoicingSteps,
} from "../../store/actions/navigation";
import {
  getContractDetails,
  getContractsList,
  setSelectedContract,
  nullContractDetails,
  setOrderlineEndDateEdit,
  setOrderlineInvoiceDateEdit,
  storeContractDetails,
  setInvoiceTwidEdit,
  updateInvoiceNumber,
} from "../../store/actions/invoicing";
import { MemoPanelComponent } from "../../components/invPreselPanel";

function Contr1() {
  const dateInputRef = useRef();
  const [editedEndDate, setEditedEndDate] = useState(null);
  const [editedInvoiceDate, setEditedInvoiceDate] = useState(null);
  const [editedTwid, setEditedTwid] = useState(null);

  const invoicingSteps = useSelector(selectInvoicingSteps);

  const selectedContract = useSelector(selectSelectedContract);
  const contractDetails = useSelector(selectContractDetails);
  const orderlineEndDateEdit = useSelector(selectOrderlineEndDateEdit);
  const orderlineInvoiceDateEdit = useSelector(selectOrderlineInvoiceDateEdit);
  const orderlineInvoiceTwid = useSelector(selectOrderlineInvoiceTwid);
  const dispatch = useDispatch();
  const appUser = useSelector(selectAppUser);
  const contractsList = useSelector(selectContractsList);

  let { contract } = useParams();
  const navigate = useNavigate();

  const validUser = (user) =>
    user
      ? !(!user.userRoles.includes("user") && !user.userRoles.includes("admin"))
      : false;

  useEffect(() => {
    dispatch(getAppUser());
    dispatch(getContractsList());
    dispatch(setSelectedContract(0));
    dispatch(setOrderlineEndDateEdit({ id: 0, date: null }));
    dispatch(setOrderlineInvoiceDateEdit({ id: 0, date: null }));
    dispatch(
      setInvoiceTwidEdit({
        id: 0,
        twid: null,
      })
    );
  }, [dispatch]);
  useEffect(() => {
    if (selectedContract === 0) {
      dispatch(nullContractDetails());
    } else {
      dispatch(getContractDetails(selectedContract));
    }
  }, [selectedContract]);
  useEffect(() => {}, [dateInputRef]);
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      dispatch(setOrderlineEndDateEdit({ id: 0, date: null }));
      dispatch(setOrderlineInvoiceDateEdit({ id: 0, date: null }));
      dispatch(setInvoiceTwidEdit({ id: 0, twid: null }));
    }
  };
  let selectedLine;
  if (contractDetails.orderLines) {
    selectedLine = contractDetails.orderLines.find(
      (line) =>
        line.qline_id === orderlineEndDateEdit.id ||
        line.qline_id === orderlineInvoiceDateEdit.id
    );
  }
  useEffect(() => {
    setEditedEndDate(selectedLine ? selectedLine.end_date_t : null);
  }, [selectedLine]);
  useEffect(() => {
    setEditedInvoiceDate(selectedLine ? selectedLine.last_invoiced_t : null);
  }, [selectedLine]);
  // useEffect(() => {
  //   setEditedTwid(selectedLine ? selectedLine.last_invoiced_t : null);
  // }, [selectedLine]);
  useEffect(() => {
    if (contract) {
      dispatch(
        storeTablesFilters({
          contractsSelect_contractId: `${contract}   `.slice(0, 4),
        })
      );
      dispatch(setSelectedContract(contract));
      navigate(`/InvoicingContracts`);
    }
  }, [dispatch, contract, navigate]);
  useEffect(() => {
    dispatch(setOrderlineEndDateEdit({ id: 0, date: null }));
  }, [dispatch, contractDetails]);
  useEffect(() => {
    const setMenu = () => {
      console.log(appUser);
      if (!validUser(appUser)) {
        dispatch(setCategories("", "", ""));
      } else {
        dispatch(setCategories("Invoicing", "Contracts"));
      }
    };
    setMenu(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, appUser]);
  if (appUser) {
    return (
      <div className="body">
        <div className="newInvoicesWrapper">
          <div className="serDetails">
            <div className="ServiceDetails">
              <div className="topBar"></div>

              <div className={`contractSelectTable`}>
                {contractsList.length > 0 ? (
                  <MemoPanelComponent
                    props={contractsList.map((line) => {
                      return {
                        ...line,
                        contractId: `${line.contractId}   `.slice(0, 4),
                      };
                    })}
                    type={"contractSelect"}
                  />
                ) : (
                  ""
                )}
              </div>
              {Object.keys(contractDetails).length > 0 ? (
                <div className="contractDetails">
                  <div className="contractInfo">
                    <MemoPanelComponent
                      type="contractInfo"
                      props={contractDetails}
                    />
                  </div>
                  {Object.keys(contractDetails).length > 0 &&
                  (orderlineEndDateEdit.id !== 0 ||
                    orderlineInvoiceDateEdit.id !== 0) ? (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Draggable>
                        <Dialog
                          hideBackdrop={true}
                          open={
                            orderlineEndDateEdit.id !== 0 ||
                            orderlineInvoiceDateEdit.id !== 0
                          }
                          onClose={handleClose}
                          // onOpe
                          // PaperComponent={PaperComponent}
                          sx={{
                            borderRadius: "20px",
                          }}
                        >
                          <DialogTitle
                            sx={{
                              minWidth: 400,
                              padding: 1,
                              maxWidth: 1000,
                              backgroundColor: "#35647e",
                              color: "white",
                              textAlign: "center",
                              marginBottom: 1,
                              fontFamily: "Quenda, serif",
                            }}
                            style={{ cursor: "move" }}
                            id="draggable-dialog-title"
                          >
                            {orderlineEndDateEdit.id !== 0
                              ? "Set the end date"
                              : "Set the invoice date"}
                          </DialogTitle>
                          <DialogContent
                            sx={{
                              minWidth: 400,
                              padding: 1,
                              maxWidth: 1000,
                              top: 5,
                            }}
                          >
                            <Box
                              component="form"
                              sx={{
                                marginTop: 0,
                                marginBottom: 0,
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "space-evenly",
                              }}
                            >
                              <p style={{ margin: "2px" }}>
                                {contractDetails.orderLines.find(
                                  (orderline) =>
                                    orderline.qline_id ===
                                      orderlineEndDateEdit.id ||
                                    orderline.qline_id ===
                                      orderlineInvoiceDateEdit.id
                                )
                                  ? contractDetails.orderLines.find(
                                      (orderline) =>
                                        orderline.qline_id ===
                                          orderlineEndDateEdit.id ||
                                        orderline.qline_id ===
                                          orderlineInvoiceDateEdit.id
                                    ).item_description
                                  : ""}
                              </p>
                            </Box>
                            <Box
                              component="form"
                              onSubmit={(e) => e.preventDefault()}
                              sx={{
                                marginTop: 0,
                                marginBottom: 0,
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "space-evenly",
                              }}
                            >
                              <AssetsDatePicker
                                ref={dateInputRef}
                                desc={
                                  orderlineEndDateEdit.id !== 0
                                    ? "End date:"
                                    : "Invoice date:"
                                }
                                value={
                                  orderlineEndDateEdit.id !== 0
                                    ? dayjs(editedEndDate)
                                    : dayjs(editedInvoiceDate)
                                }
                                onChangeFunc={(value) => {
                                  orderlineEndDateEdit.id !== 0
                                    ? setEditedEndDate(value)
                                    : setEditedInvoiceDate(value);
                                }}
                              />
                            </Box>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              variant="contained"
                              sx={{
                                fontFamily: "Quenda, serif !important",
                                background: "#35647e",
                                color: "white",
                              }}
                              onClick={async (e) => {
                                setEditedEndDate(null);
                                setEditedInvoiceDate(null);
                              }}
                            >
                              Clear
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                fontFamily: "Quenda, serif !important",
                                background: "#f9323f",
                                color: "white",
                              }}
                              onClick={(e) => {
                                setEditedEndDate(null);
                                setEditedInvoiceDate(null);
                                handleClose();
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                fontFamily: "Quenda, serif !important",
                                background: "#4ab217",
                                color: "white",
                              }}
                              disabled={
                                editedEndDate === null &&
                                editedInvoiceDate === null
                                  ? false
                                  : !new Date(editedEndDate).getDate() &&
                                    !new Date(editedInvoiceDate).getDate()
                                  ? true
                                  : false
                              }
                              onClick={async (e) => {
                                let updatedLineIndex =
                                  contractDetails.orderLines.indexOf(
                                    contractDetails.orderLines.find(
                                      (orderline) =>
                                        orderline.qline_id ===
                                          orderlineEndDateEdit.id ||
                                        orderline.qline_id ===
                                          orderlineInvoiceDateEdit.id
                                    )
                                  );
                                // let updatedLine = {
                                //   ...contractDetails.orderLines[updatedLineIndex],
                                //   end_date_t: !editedEndDate
                                //     ? null
                                //     : new Date(editedEndDate).toISOString(),
                                // };
                                let updatedLine;
                                if (orderlineEndDateEdit.id !== 0) {
                                  updatedLine = {
                                    ...contractDetails.orderLines[
                                      updatedLineIndex
                                    ],
                                    end_date_t: !editedEndDate
                                      ? null
                                      : new Date(editedEndDate).toISOString(),
                                  };
                                } else if (orderlineInvoiceDateEdit.id !== 0) {
                                  updatedLine = {
                                    ...contractDetails.orderLines[
                                      updatedLineIndex
                                    ],
                                    last_invoiced_t: !editedInvoiceDate
                                      ? null
                                      : new Date(
                                          editedInvoiceDate
                                        ).toISOString(),
                                  };
                                }
                                let newArr = [...contractDetails.orderLines];
                                newArr[updatedLineIndex] = updatedLine;
                                dispatch(
                                  storeContractDetails({
                                    ...contractDetails,
                                    orderLines: newArr,
                                  })
                                );
                                dispatch(
                                  setInvoicingSteps({
                                    ...invoicingSteps,
                                    orLineEdit: true,
                                  })
                                );
                                handleClose();
                                setEditedEndDate(null);
                                setEditedInvoiceDate(null);
                              }}
                            >
                              Ok
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Draggable>
                    </LocalizationProvider>
                  ) : Object.keys(contractDetails).length > 0 &&
                    orderlineInvoiceTwid.id !== 0 ? (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Draggable>
                        <Dialog
                          hideBackdrop={true}
                          open={orderlineInvoiceTwid.id !== 0}
                          onClose={handleClose}
                          onAnimationEnd={() =>
                            setEditedTwid(orderlineInvoiceTwid.twid)
                          }
                          // PaperComponent={PaperComponent}
                          sx={{
                            borderRadius: "20px",
                          }}
                        >
                          <DialogTitle
                            sx={{
                              minWidth: 400,
                              padding: 1,
                              maxWidth: 1000,
                              backgroundColor: "#35647e",
                              color: "white",
                              textAlign: "center",
                              marginBottom: 1,
                              fontFamily: "Quenda, serif",
                            }}
                            style={{ cursor: "move" }}
                            id="draggable-dialog-title"
                          >
                            {"Set the invoice number"}
                          </DialogTitle>
                          <DialogContent
                            sx={{
                              minWidth: 400,
                              padding: 1,
                              maxWidth: 1000,
                              top: 5,
                            }}
                          >
                            <Box
                              component="form"
                              onSubmit={(e) => e.preventDefault()}
                              sx={{
                                marginTop: 0,
                                marginBottom: 0,
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "space-evenly",
                              }}
                            >
                              <AssetsTextInput2
                                ref={dateInputRef}
                                desc={"Invoice no.:"}
                                descClass="invoiceNumberEdit"
                                value={editedTwid}
                                onChangeFunc={(value) => {
                                  setEditedTwid(value);
                                }}
                              />
                            </Box>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              variant="contained"
                              sx={{
                                fontFamily: "Quenda, serif !important",
                                background: "#f9323f",
                                color: "white",
                              }}
                              onClick={(e) => {
                                setEditedEndDate(null);
                                setEditedInvoiceDate(null);
                                setEditedTwid(null);
                                handleClose();
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                fontFamily: "Quenda, serif !important",
                                background: "#4ab217",
                                color: "white",
                              }}
                              disabled={
                                !editedTwid ||
                                (editedTwid && editedTwid.length < 1)
                              }
                              onClick={async (e) => {
                                dispatch(
                                  updateInvoiceNumber({
                                    twid: editedTwid,
                                    invoiceId: orderlineInvoiceTwid.id,
                                  })
                                );
                                handleClose();
                                setEditedEndDate(null);
                                setEditedInvoiceDate(null);
                                dispatch(nullContractDetails());
                                dispatch(getContractDetails(selectedContract));
                              }}
                            >
                              Ok
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Draggable>
                    </LocalizationProvider>
                  ) : (
                    ""
                  )}
                  <div>
                    <MemoPanelComponent
                      type={"contractInvoices"}
                      props={contractDetails.invoices}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return "";
  }
}

export default Contr1;
